import AmplifyEventBus from './plugins/aws-amplify-vue/events/AmplifyEventBus';
import {
    store
} from "./Store"
if (import.meta.env.PROD) {
    navigator.serviceWorker
        .register(`${import.meta.env.BASE_URL}service-worker.js`)
        .then((registration) => {
            console.log('Service worker registered.')
            AmplifyEventBus.on('sw', event => {
                if (event === 'CHECK_UPDATES') {
                    registration.update()
                }
            })

            // Track SW version in localStorage so we can detect same-version
            // re-activations (e.g. Lighthouse) and skip the reload
            let pendingReload = false
            navigator.serviceWorker.addEventListener('message', (event) => {
                if (event.data?.type === 'SW_ACTIVATE_STARTED') {
                    const newVersion = event.data.version
                    const oldVersion = localStorage.getItem('sw-version')
                    localStorage.setItem('sw-version', newVersion)
                    if (pendingReload) {
                        pendingReload = false
                        if (newVersion !== oldVersion) {
                            console.log(`SW updated: ${oldVersion} → ${newVersion}, reloading`)
                            localStorage.setItem('genoUpdated', true)
                            AmplifyEventBus.emit('sw', 'reloadPage')
                        } else {
                            console.log(`SW re-activated with same version ${newVersion}, skipping reload`)
                        }
                    }
                }
            })

            // controllerchange fires before SW_ACTIVATE_STARTED, so just
            // set a flag and let the message handler decide whether to reload
            let handled = false
            navigator.serviceWorker.addEventListener('controllerchange', () => {
                if (handled) return
                handled = true
                pendingReload = true
            })

            registration.addEventListener('updatefound', () => {
                // On a fresh install there is no active worker yet — skip the
                // "updating" toast and reload cycle; this is not an update.
                if (!registration.active) return;

                const newWorker = registration.installing
                newWorker.addEventListener('statechange', () => {
                    if (newWorker.state === 'redundant') return
                    if (newWorker.state === 'installed') {
                        console.log('Updating version...')
                        newWorker.postMessage({ type: 'SKIP_WAITING' })
                    }
                })
            })
        })
        .catch((error) => {
            console.error('SW registration error:', error)
        })
}
